import { ProfileModel } from '../../profile/model/profile.model';
import { ModuleModel } from '../../module.model.interface';
import { FormDescriptor } from '../../form/model/form';
import { OrganizationModel } from '../../organization/model/organization.model';

export enum DataEntryState {
  Created,
  Saved,
  Received,
  ProcessedCurrent,
  ProcessedOverwritten
}

export class DataEntryStateDetail {
  public id: string;
  public name: string;

  constructor(options?: {
    id: string,
    name: string,
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
    }
  }
}

export const DataEntryStateMap = {
  Created: new DataEntryStateDetail({ id: 'Created', name: 'Létrehozva'}),
  Saved: new DataEntryStateDetail({ id: 'Saved', name: 'Mentve'}),
  Received: new DataEntryStateDetail({ id: 'Received', name: 'Betöltés alatt'}),
  ProcessedCurrent: new DataEntryStateDetail({ id: 'ProcessedCurrent', name: 'Beküldve (aktuális)'}),
  ProcessedOverwritten: new DataEntryStateDetail({ id: 'ProcessedOverwritten', name: 'Beküldve (felülírva)'}),
};

export const DataEntryStateList: DataEntryStateDetail[] = [
  DataEntryStateMap.Created,
  DataEntryStateMap.Saved,
  DataEntryStateMap.Received,
  DataEntryStateMap.ProcessedCurrent,
  DataEntryStateMap.ProcessedOverwritten,
];

export const DataEntryStateListUnSubmitted: DataEntryStateDetail[] = [
  DataEntryStateMap.Created,
  DataEntryStateMap.Saved,
];

export const DataEntryStateListSubmitted: DataEntryStateDetail[] = [
  DataEntryStateMap.ProcessedCurrent,
  DataEntryStateMap.ProcessedOverwritten,
];

export enum DataEntryProcessingState {
  None,
  Unverified,
  VerificationSuspended,
  VerifiedModificationRequested,
  VerifiedAccepted,
  VerifiedAcceptedWithModification,
  VerifiedMarkedAsInvalid,
  VerifiedAcceptedOverwritten,
  VerifiedAcceptedWithModificationOverwritten,
}

export class DataEntryProcessingStateDetail {
  public id: string;
  public name: string;

  constructor(options?: {
    id: string,
    name: string,
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
    }
  }
}

export const DataEntryProcessingStateMap = {
  None: new DataEntryProcessingStateDetail({ id: 'None', name: 'Nem beküldött'}),
  Unverified: new DataEntryProcessingStateDetail({ id: 'Unverified', name: 'Nem ellenőrzött'}),
  VerificationSuspended: new DataEntryProcessingStateDetail({ id: 'VerificationSuspended', name: 'Félretéve'}),
  VerifiedModificationRequested: new DataEntryProcessingStateDetail({ id: 'VerifiedModificationRequested', name: 'Módosításra visszaküldve'}),
  VerifiedAccepted: new DataEntryProcessingStateDetail({ id: 'VerifiedAccepted', name: 'Elfogadva (aktuális)'}),
  VerifiedAcceptedWithModification: new DataEntryProcessingStateDetail({ id: 'VerifiedAcceptedWithModification', name: 'Módosítással elfogadva (aktuális)'}),
  VerifiedMarkedAsInvalid: new DataEntryProcessingStateDetail({ id: 'VerifiedMarkedAsInvalid', name: 'Elvetve'}),
  VerifiedAcceptedOverwritten: new DataEntryProcessingStateDetail({ id: 'VerifiedAcceptedOverwritten', name: 'Elfogadva (felülírva)'}),
  VerifiedAcceptedWithModificationOverwritten: new DataEntryProcessingStateDetail({ id: 'VerifiedAcceptedWithModification', name: 'Módosítással elfogadva (felülírva)'}),
};

export const DataEntryProcessingStateList: DataEntryProcessingStateDetail[] = [
  DataEntryProcessingStateMap.None,
  DataEntryProcessingStateMap.Unverified,
  DataEntryProcessingStateMap.VerificationSuspended,
  DataEntryProcessingStateMap.VerifiedModificationRequested,
  DataEntryProcessingStateMap.VerifiedAccepted,
  DataEntryProcessingStateMap.VerifiedAcceptedWithModification,
  DataEntryProcessingStateMap.VerifiedMarkedAsInvalid,
  DataEntryProcessingStateMap.VerifiedAcceptedOverwritten,
  DataEntryProcessingStateMap.VerifiedAcceptedWithModificationOverwritten,
];

export enum ValidationState {
  None,
  Waiting,
  Validated,
  Failed
}

export class ValidationStateDetail {
  public id: string;
  public name: string;

  constructor(options?: {
    id: string,
    name: string,
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
    }
  }
}

export const ValidationStateMap = {
  None: new ValidationStateDetail({ id: 'None', name: 'Nincs'}),
  Waiting: new ValidationStateDetail({ id: 'Waiting', name: 'Ellenőrzésre vár'}),
  Validated: new ValidationStateDetail({ id: 'Validated', name: 'Ellenőrzött'}),
  Failed: new ValidationStateDetail({ id: 'Failed', name: 'Hibás'})
};

export const ValidationStateList: ValidationStateDetail[] = [
  ValidationStateMap.None,
  ValidationStateMap.Waiting,
  ValidationStateMap.Validated,
  ValidationStateMap.Failed
];

export class DataEntryDescriptor implements ModuleModel {
  public discriminator = 'DataEntryDescriptor';

  public id: string;
  public rootDataEntryId: string;
  public formId: string;
  public organizationId: string;
  public periodStart: Date;
  public reference: string;
  public version: number;
  public dataEntryState: DataEntryState;
  public dataEntryProcessingState: DataEntryProcessingState;
  public submittedById: string;
  public submittedOn: DateConstructor;
  public dueDate: DateConstructor;
  public warnDate: DateConstructor;
  public validationState: ValidationState;
  public validatedOn: DateConstructor;
  public clerkId: string;
  public additionalInformation: string;
  public createdById: string;
  public createdOn: DateConstructor;
  
  public href: string;
  public modified: Date;
  public deleted: Date;
  
  public createdByDetail?: ProfileModel;
  public createdByFullName?: string;
  public submittedByDetail?: ProfileModel;
  public submittedByFullName?: string;
  public submittedByEmailAddress?: string;
  public submittedByPhoneNumber?: string;
  public submittedByUserName?: string;
  public formDetail?: FormDescriptor;
  public formTitle?: string;
  public formVersion?: number;
  public formIdentifier?: string;
  public formName?: string;
  public isDeletable?: boolean;

  public organizationDetail?: OrganizationModel;
  public organizationTitle?: string;
  public organizationMekhCode?: string;
  public organizationMekhCodeInternal?: string;
  public organizationAddress?: string;
  public organizationName?: string;
  public clerkDetail?: ProfileModel;
  public clerkFullName?: string;

  constructor(options?: {
    id: string;

    rootDataEntryId: string;
    formId: string;
    organizationId: string;
    periodStart: Date;
    reference: string;
    version: number;
    dataEntryState: DataEntryState;
    dataEntryProcessingState: DataEntryProcessingState;
    submittedById: string;
    submittedOn: DateConstructor;
    dueDate: DateConstructor;
    warnDate: DateConstructor;
    validationState: ValidationState;
    validatedOn: DateConstructor;
    clerkId: string;
    additionalInformation: string;
    createdById: string;
    createdOn: DateConstructor;
  
    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.rootDataEntryId = options.rootDataEntryId;
      this.formId = options.formId;
      this.organizationId = options.organizationId;
      this.periodStart = options.periodStart;
      this.reference = options.reference;
      this.version = options.version;
      this.dataEntryState = options.dataEntryState;
      this.dataEntryProcessingState = options.dataEntryProcessingState;
      this.submittedById = options.submittedById;
      this.submittedOn = options.submittedOn;
      this.dueDate = options.dueDate;
      this.warnDate = options.warnDate;
      this.validationState = options.validationState;
      this.validatedOn = options.validatedOn;
      this.clerkId = options.clerkId;
      this.additionalInformation = options.additionalInformation;
      this.createdById = options.createdById;
      this.createdOn = options.createdOn;
      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}

export enum DataEntryMachineAttributeName {
    Data,
    Reason,
    Comment
}

export class DataEntryMachineAttribute {
  public name: DataEntryMachineAttributeName;
  public value: string;

  constructor(options?: {
    name: DataEntryMachineAttributeName;
    value: string;
  }) {

    if (options) {
      this.name = options.name;
      this.value = options.value;
    }
  }
}

export enum DataEntryMachineCommand {
    Save,
    Submit,
    Process,
    Overwrite,
    Suspend,
    RequestClarification,
    Accept,
    AcceptWithModification,
    MarkAsInvalid,
    OverwriteAccept,
    SubmitAsync
}

export const DataEntryMachineCommandMessage = {
  Save : { inprogress:'Mentés folyamatban...', done: 'Az adatszolgáltatás mentése sikeresen megtörtént, azonban felhívjuk figyelmét, hogy a mentés NEM egyenértékű a beküldéssel!', fail: 'Az adatszolgáltatás mentése nem sikerült.' },
  Submit : { inprogress:'Beküldés folyamatban...', done: 'Az adatszolgáltatást rendszerünk sikeresen fogadta. Az adatszolgáltatás sikeres alapszintű ellenőrzés esetén beküldött állapotúvá válik.', fail: 'Az adatszolgáltatást rendszerünk nem tudta fogadni.' },
  Process : { inprogress:'', done: '### nem engedélyezett ###', fail: '### nem engedélyezett ###' },
  Overwrite : { inprogress:'', done: '### nem engedélyezett ###', fail: '### nem engedélyezett ###' },
  Suspend : { inprogress:'Felfüggesztés folyamatban...', done: 'Az adatszolgáltatás ellenőrzését sikeresen felfüggesztette.', fail: 'Az adatszolgáltatás ellenőrzését nem sikerült felfüggesztenie.' },
  RequestClarification : { inprogress:'Adategyeztetés elkezdése folyamatban...', done: 'Az adatszolgáltatás pontosítását sikeresen kérelmezte.', fail: 'Az adatszolgáltatás pontosítását nem sikerült kérelmeznie.' },
  Accept : { inprogress:'Elfogadás folyamatban...', done: 'Az adatszolgáltatást sikeresen elfogadta.', fail: 'Az adatszolgáltatás elfogadása nem sikerült.' },
  AcceptWithModification : { inprogress:'Elfogadás módosítással folyamatban...', done: 'Az adatszolgáltatást módosítással sikeresen elfogadta.', fail: 'Az adatszolgáltatás módosítással elfogadása nem sikerült.' },
  MarkAsInvalid : { inprogress:'Érvénytelenítés folyamatban...', done: 'Az adatszolgáltatást sikeresen érvénytelenítette.', fail: 'Az adatszolgáltatást nem sikerült érvénytelenítenie.' },
  OverwriteAccept : { inprogress:'', done: '### nem engedélyezett ###', fail: '### nem engedélyezett ###' },
  SubmitAsync : { inprogress:'Beküldés folyamatban...', done: 'Az adatszolgáltatást rendszerünk sikeresen fogadta. Az adatszolgáltatás sikeres alapszintű ellenőrzés esetén beküldött állapotúvá válik.', fail: 'Az adatszolgáltatást rendszerünk nem tudta fogadni.' },
};

export const DataEntryMachineCommandMap = {
  Accept : { name: 'elfogadás' },
  Suspend : { name: 'félretétel' },
  AcceptWithModification : { name: 'elfogadás módosítással' },
  MarkAsInvalid : { name: 'elvetés' }
};

export class DataEntryMachineStateDescriptor implements ModuleModel {
  public discriminator = 'DataEntryMachineStateDescriptor';

  public command?: DataEntryMachineCommand;
  public attributes?: DataEntryMachineAttribute[];

  constructor(options?: {
    command?: DataEntryMachineCommand;
    attributes?: DataEntryMachineAttribute[];
    }) {

    if (options) {
      this.command = options.command;
      this.attributes = options.attributes;
    }
  }
}

export enum ManifestType {
  Data,
}

export class ManifestTypeDetail {
  public id: string;
  public name: string;

  constructor(options?: {
    id: string,
    name: string,
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
    }
  }
}

export const ManifestTypeMap = {
  Data: new ManifestTypeDetail({ id: 'Data', name: 'Adatszolgáltatás (xml)'} ),
};

export const ManifestTypeList: ManifestTypeDetail[] = [
  ManifestTypeMap.Data,
];


export class DataEntryManifestDescriptor implements ModuleModel {
  public discriminator = 'DataEntryManifestDescriptor';

  public id: string;
  public dataEntryId: string;
  public manifestType: ManifestType;
  public size: number;
  public body: string;
  public version: number;

  public createdById: string;
  public createdOn: DateConstructor;

  public href: string;
  public modified: Date;
  public deleted: Date;

  public createdByDetail?: ProfileModel;
  public createdByFullName?: string;

  constructor(options?: {
    id: string;

    dataEntryId: string;
    manifestType: ManifestType;
    size: number;
    body: string;
    version: number;

    createdById: string;
    createdOn: DateConstructor;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.dataEntryId = options.dataEntryId;
      this.manifestType = options.manifestType;
      this.size = options.size;
      this.body = options.body;
      this.version = options.version;
      this.createdById = options.createdById;
      this.createdOn = options.createdOn;

      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}

export class DataEntryAttachmentDescriptor implements ModuleModel {
  public discriminator = 'DataEntryAttachmentDescriptor';

  public id: string;
  public dataEntryId: string;
  public alias: string;
  public size: number;
  public body: string;

  public createdById: string;
  public createdOn: DateConstructor;

  public href: string;
  public modified: Date;
  public deleted: Date;

  public createdByDetail?: ProfileModel;
  public createdByFullName?: string;

  constructor(options?: {
    id: string;
    dataEntryId: string;
    alias: string;
    size: number;
    body: string;

    createdById: string;
    createdOn: DateConstructor;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.dataEntryId = options.dataEntryId;
      this.alias = options.alias;
      this.size = options.size;
      this.body = options.body;
      this.createdById = options.createdById;
      this.createdOn = options.createdOn;

      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}

export class FormOrganizationDescriptor implements ModuleModel {
  public discriminator = 'FormOrganizationDescriptor';

  public formId: string;
  public organizationId: string;

  constructor(options?: {
    formId: string;
    organizationId: string;
  }) {

    if (options) {
      this.formId = options.formId;
      this.organizationId = options.organizationId;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/modules/dataentry/model/dataentry.ts